/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseURL: 域名地址
 * imgBaseUrl: 图片所在域名地址
 *
 */

let URL = {
}

let ProjectSettings = window.config.Project;

// development 开发环境1
if (process.env.NODE_ENV === 'development') {
  URL.baseURL = window.config.DevURL.baseURL;
  URL.baseNewURL = window.config.DevURL.baseNewURL;
} else {
  URL.baseURL = window.config.BuildURL.baseURL;
  URL.baseNewURL = window.config.BuildURL.baseNewURL;
}

export {
  URL,
  ProjectSettings
}



// WEBPACK FOOTER //
// ./src/config/env.js